"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterIcon = void 0;
const react_1 = __importDefault(require("react"));
const FilterIcon = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: "0" }),
        react_1.default.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("g", { id: "SVGRepo_iconCarrier" },
            react_1.default.createElement("path", { d: "M0 3.5H16V0.5H0V3.5Z", fill: props.fill }),
            react_1.default.createElement("path", { d: "M2 8.5H14V5.5H2V8.5Z", fill: props.fill }),
            react_1.default.createElement("path", { d: "M4 13.5H12V10.5H4V13.5Z", fill: props.fill }))));
};
exports.FilterIcon = FilterIcon;
